import { createContext } from 'react';

// Shared context for NudgeGateProvider — kept in its own file so
// NudgeGateProvider.tsx only exports components (react-refresh requirement).
export interface NudgeSlotInfo {
  nudgeId: string;
  priority: number;
  requestedAt: number;
}

export interface NudgeGateContextValue {
  hasSlot: (nudgeId: string) => boolean;
  requestSlot: (nudgeId: string, priority: number) => void;
  releaseSlot: (nudgeId: string) => void;
  getAvailableSlots: () => number;
}

export const NudgeGateContext = createContext<NudgeGateContextValue | null>(null);
// displayName improves React DevTools labelling and ensures this module
// produces a distinct compiled output (affecting the Vite chunk hash).
NudgeGateContext.displayName = 'NudgeGate';
